export const ShortDateFormat = 'dd.MM.yyyy' as const
export const DateFormat = 'do MMMM yyyy' as const
export const LongDateFormat = 'EEEE, do MMMM yyyy' as const
export const TimeFormat = 'HH:mm' as const
